import React from 'react'
import PropTypes, { number, string } from 'prop-types'

const JaFlagIcon = ({ size = '36' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 34 34" fill="none">
      <path
        d="M29.6936 -0.0087249H4.33651C3.37418 -0.00989016 2.43971 0.314764 1.68477 0.912527C0.793875 1.60914 0.210722 2.62746 0.0601927 3.74943C0.0327342 3.93762 0.0183709 4.1275 0.0172119 4.31768V29.6606C0.0176381 30.536 0.284504 31.3904 0.782222 32.11C1.03667 32.4709 1.34215 32.7928 1.68906 33.0657C2.44398 33.6605 3.37605 33.9848 4.33651 33.987H29.6936C30.8307 33.978 31.9186 33.5215 32.7227 32.7161C33.5267 31.9108 33.9824 30.821 33.9914 29.6821V4.3263C33.9881 3.18362 33.5349 2.08839 32.7302 1.27838C31.9255 0.468367 30.8344 0.00895726 29.6936 -0.000106719V-0.0087249ZM17.0065 27.1121C15.0062 27.1129 13.0506 26.5195 11.387 25.407C9.72335 24.2945 8.42651 22.7128 7.66044 20.862C6.89437 19.0112 6.69349 16.9744 7.0832 15.0092C7.47292 13.044 8.43573 11.2387 9.84986 9.82163C11.264 8.40457 13.0659 7.43942 15.0277 7.04823C16.9895 6.65703 19.023 6.85737 20.8712 7.62391C22.7193 8.39045 24.2989 9.68877 25.4103 11.3546C26.5217 13.0205 27.1149 14.9791 27.1149 16.9827C27.1104 19.667 26.0441 22.2402 24.1495 24.1387C22.2549 26.0372 19.6864 27.1064 17.0065 27.1121Z"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0065 6.87927C15.006 6.87842 13.0502 7.47189 11.3865 8.5846C9.72281 9.6973 8.42596 11.2792 7.66002 13.1303C6.89408 14.9814 6.69345 17.0185 7.08351 18.9838C7.47358 20.9491 8.43682 22.7544 9.85137 24.1712C11.2659 25.5881 13.0682 26.553 15.0303 26.9437C16.9924 27.3344 19.0261 27.1334 20.8741 26.3662C22.7222 25.599 24.3015 24.3 25.4124 22.6336C26.5233 20.9671 27.1158 19.0081 27.1149 17.0044C27.1104 14.3204 26.0439 11.7477 24.1492 9.84987C22.2545 7.95203 19.686 6.88383 17.0065 6.87927Z"
        fill="#D90012"
      />
    </svg>
  )
}

export default React.memo(JaFlagIcon)

JaFlagIcon.propTypes = {
  size: PropTypes.oneOfType([string, number]),
}
